import { Component, OnInit, Input } from '@angular/core';
import { ContactData } from '@bo-client/shared/models/contactData';
import { MetaService } from '@bo-client/core/api/meta-service';
import { RegexToCheckEMail } from '@bo-client/shared/forms/forms.validators';

@Component({
  selector: 'app-edit-contact-data',
  templateUrl: './edit-contact-data.component.html',
  styleUrls: ['./edit-contact-data.component.scss']
})
export class EditContactDataComponent implements OnInit {
  @Input() showAddress = true;
  @Input() showContact = true;
  @Input() disableFieldsForInstaller = false;
  @Input() data: ContactData = {}; // assignment funktioniert scheinbar nicht, wenn null als Wert übergeben wird
  @Input() infoText = '';

  constructor(protected metaService: MetaService) {}

  ngOnInit() {
    this.data = this.data || {};
    if (!this.data?.salutation) {
      this.data.salutation = '';
    }
  }

  protected readonly RegexToCheckEMail = RegexToCheckEMail;
}
